/** API route map: URLS.Controller.ReferenceCheck */
export const ReferenceCheck = {
      Name: 'ReferenceCheck/',
      GetAllReferenceCheckTemplatesPaginated: 'get-all-reference-check-templates-paginated',
      GetAllReferenceCheckTemplates: 'get-all-reference-check-templates',
      GetReferenceCheckQuestionnaire: 'get-reference-check-questionnaires',
      AddReferenceCheckQuestionnaire: 'add-reference-check-questionnaire',
      EditReferenceCheckQuestionnaire: 'edit-reference-check-questionnaire',
      DeleteReferenceCheckQuestionnaire: 'delete-reference-check-questionnaire',
};
